/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum mccs_vehicle_review_request_status {
  PENDING = 'pending',
  MORE_INFO_NEEDED = 'more_info_needed',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  CANCELLED = 'cancelled',
}
